module.exports = __webpack_public_path__ + "img/04f78d5.png";